export const initialState = {
    indexVisibility: 0,
    refreshIndex: 0,
}

export const reducer = (state, action) => {
    switch (action.type) {
        case "set_index_visibility":
            return { ...state, indexVisibility: action.payload };
        case "refresh_list":
            return { ...state, refreshIndex: state.refreshIndex + 1 };
        default:
            return state;
    }
}
